import React from "react";
import { Link as AppLink } from "@/i18n/routing";

export default function Link({ href, children, ...props }) {
  const isExternal = /^https?:\/\//i.test(href) || href.startsWith("mailto:") || href.startsWith("tel:");
  if (isExternal) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
  return (
    <AppLink href={href} {...props}>
      {children}
    </AppLink>
  );
}
